import { z } from 'zod'

export const clubPostTypeEnum = z.enum(['POST', 'ANNOUNCEMENT'])

export const createClubPostSchema = z.object({
  title: z.string().min(1, 'Title is required').max(200, 'Title must be 200 characters or less'),
  content: z.string().min(1, 'Content is required').max(10000, 'Content must be 10000 characters or less'),
  type: clubPostTypeEnum.default('POST'),
  reshare: z.boolean().default(false),
})

export const updateClubPostSchema = z.object({
  title: z.string().min(1, 'Title is required').max(200, 'Title must be 200 characters or less').optional(),
  content: z.string().min(1, 'Content is required').max(10000, 'Content must be 10000 characters or less').optional(),
})

export const clubPostQuerySchema = z.object({
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(50).default(20),
  type: clubPostTypeEnum.optional(),
})

export const createClubPostCommentSchema = z.object({
  content: z.string().min(1, 'Comment is required').max(2000, 'Comment must be 2000 characters or less'),
})

export type CreateClubPostInput = z.infer<typeof createClubPostSchema>
export type UpdateClubPostInput = z.infer<typeof updateClubPostSchema>
export type ClubPostQueryInput = z.infer<typeof clubPostQuerySchema>
export type CreateClubPostCommentInput = z.infer<typeof createClubPostCommentSchema>
